// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".add-to-cart-btn[data-v-47344e98]{background:var(--prime2);color:#fff}.add-to-cart-btnhover[data-v-47344e98]{background:#d82c97}", "",{"version":3,"sources":["webpack://./assets/main/vue/AddToCartButtonWithSpinner.vue"],"names":[],"mappings":"AACA,kCACE,wBAAA,CACA,UAAA,CAEA,uCACE,kBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
